import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = '/chat';

class ChatService {
  getAllChatRooms = async (page, search) => {
    try {
      if (!search) {
        search = '';
      }
      const response = await axiosApiClient.get(`${BASE_URL}/vendor?page=${page}&search=${search}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message, maxReached, total } = response.data;

      return { data, message, maxReached, total, page };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching chat rooms.');
    }
  };

  getChatRoom = async (id, page) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/vendor/${id}?page=${page}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, key, client, message, maxReached, total } = response.data;

      return { data, key, id, client, message, maxReached, total, page };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching chat room.');
    }
  };

  sendMediaInChat = async (body, id) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/media/${id}`, body);
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      console.log(err);
      throw handleError(err, 'Error occurred while sending media message chat room');
    }
  };
}
const chatService = new ChatService();

export default chatService;
